import { validateTextSchema } from 'utils/commonSchema';
import * as yup from 'yup';
import { RELATIONSHIPS, QBEBUSINESSLIST } from './enum';

yup.setLocale({
  mixed: {
    oneOf: '',
    required: '',
  },
});

const emailRegex =
  /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;
const phoneNumberRegex =
  /^(([0-9]{6,20})|([+]?[(]?(([2-9][0-9])|([2-8][0-9][0-9]))[)]?[-\s.]?[0-9]{3}[-\s]?[0-9]{4,6}))$/;
const textFieldMax = 50;
const textFieldMin = 4;
const textMin = 1;
const orgMax = 100;

const personalDetailsSchemaObject = {
  relationship: yup.string().oneOf(RELATIONSHIPS).required('Relationship is required'),

  qbeBusiness: yup.string().oneOf(QBEBUSINESSLIST).required(),

  firstName: validateTextSchema({ minLen: textMin, maxLen: textFieldMax, required: true }),

  lastName: validateTextSchema({ minLen: textMin, maxLen: textFieldMax, required: true }),

  organisation: validateTextSchema({ minLen: textMin, maxLen: orgMax, required: true }),
};

export const contactDetailSchemaObject = {
  emailAddress: yup
    .string()
    .matches(emailRegex, 'Please enter a valid email address')
    .max(orgMax)
    .required('Please enter a valid email address'),

  phoneNumber: yup
    .string()
    .matches(phoneNumberRegex, 'Please enter a valid phone number')
    .min(textFieldMin)
    .max(20)
    .required('Please enter a valid phone number'),
};

export const personalDetailsSchema = yup.object().shape(personalDetailsSchemaObject);
export const contactDetailSchema = yup.object().shape(contactDetailSchemaObject);

const validationSchema = yup.object().shape({
  ...personalDetailsSchemaObject,
  ...contactDetailSchemaObject,
});

export default validationSchema;
